import { Divider, Grid } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm, useFieldArray, get } from "react-hook-form";
import { useParams } from "react-router-dom";
import "../../../App.css";
import {
  getAssessmentTemplatesByProfessional,
  sendAssessmentAnswerMonitoring,
} from "../../../models/actions/Assessment";
import { labels, psTranslate } from "../../../pages/shared/translations";
import SpButton from "../../atoms/SpButton";
import { withSnackbar } from "../../atoms/SpSnackBar";
import SpText from "../../atoms/SpText";
import { styled } from "../../styled";
import { SpSelect, SpSelectMenuItem } from "../../atoms/SpSelect";
import SpTextInput from "../../atoms/SpTextInput";
import { titleCase } from "../../../utils/common";

const StyledBodyColumn = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  paddingRight: "2%",
  marginBottom: "3%",
});

const AddMonitoringAssessment = ({
  setLoading,
  assessmentDetail,
  isRepeatAssessment,
  isRepeatFromTemplate,
  closeAssessmentAdd,
  selectedCategoriesObj,
  date,
  idTemplate,
  ...props
}) => {
  //States
  const [answers, setAnswers] = useState({});
  const [assessmentTemplatesList, setAssessmentTemplatesList] = useState([]);
  const [selectedAssessmentTemplate, setSelectedAssessmentTemplate] =
    useState(null);

  //Hook form
  const { control, getValues } = useForm({
    name: "category",
    shouldUnregister: false,
  });

  const { patId } = useParams();

  //Effects
  const fetchData = async () => {
    setLoading(true);
    try {
      if (!assessmentDetail) {
        //fetch assessments templates list
        let assessmentsTempListData =
          await getAssessmentTemplatesByProfessional();

        setAssessmentTemplatesList(assessmentsTempListData);
      } else {
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveAnswers = async () => {
    setLoading(true);
    const body = {
      id_patient: patId,
      id_test: selectedAssessmentTemplate,
      date: getValues("date"),
      answers,
    };
    const response = await sendAssessmentAnswerMonitoring(body);
    if (response.message) {
      props.snackbarShowMessage(response.message);
    } else {
      props.snackbarShowErrorMessage(response.error);
    }
    setLoading(false);
  };

  return (
    <>
      <div>
        <StyledBodyColumn>
          {!selectedAssessmentTemplate && (
            <Grid item xs={12}>
              <Grid item xs={4}>
                <Controller
                  render={(props) => (
                    <SpSelect
                      allowDeselect={true}
                      label={
                        labels.patient.monitoring.assessments.inputs
                          .selectTemplate
                      }
                      value={props.value}
                      formControlWidth={"100%"}
                      onChange={(e) => {
                        props.onChange(e.target.value);
                        setSelectedAssessmentTemplate(e.target.value);
                      }}
                    >
                      {assessmentTemplatesList.map((p) => (
                        <SpSelectMenuItem key={p.id} value={p.id}>
                          {p.name}
                        </SpSelectMenuItem>
                      ))}
                    </SpSelect>
                  )}
                  defaultValue={""}
                  name={`assessmentTemplate`}
                  control={control}
                />
              </Grid>
            </Grid>
          )}
          {selectedAssessmentTemplate && (
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Controller
                  render={(props) => (
                    <>
                      <SpText variant="listHeader">
                        {
                          labels.mylab.tempAdd.excerciseSheet.list.header
                            .duration
                        }
                      </SpText>
                      <SpTextInput
                        type="date"
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          props.onChange(e.target.value);
                        }}
                        value={getValues("date")}
                      />
                    </>
                  )}
                  defaultValue={moment().format("YYYY-MM-DD")}
                  name={`date`}
                  control={control}
                />
              </Grid>
              <Grid item xs={4}>
                <SpButton
                  buttonType="accept"
                  style={{ maxWidth: "25%", marginTop: "2em" }}
                  onClick={saveAnswers}
                  text={labels.groups.groupDetail.actions.save}
                />
              </Grid>
              <Grid container spacing={2}>
                {assessmentTemplatesList
                  .find((x) => x.id == selectedAssessmentTemplate)
                  ?.test_questions?.map((quest, idx) => (
                    <Grid item xs={4} key={quest.id}>
                      <SpText variant="listHeader">
                        {titleCase(psTranslate(quest.name))} [{quest?.um}]
                      </SpText>
                      <SpTextInput
                        type="text"
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          setAnswers({
                            ...answers,
                            [quest.id]: e.target.value,
                          });
                        }}
                        value={answers[quest.id] ? answers[quest.id] : ""}
                      />
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          )}
        </StyledBodyColumn>
      </div>
    </>
  );
};

export default withSnackbar(AddMonitoringAssessment);
